import Picklist from "./picklist/Picklist";

export default function picklistClassFactory(name: string) {
    return new Picklist(name);
}